import React, {useEffect, useState} from 'react';

import Calender from '../Reusables/Calender';
import Dropdown from '../Reusables/Dropdown';
import { convertToDateString, trim } from '../Reusables/Function';


function EntityAdditional(props) {
    const {page, values, setValues, labelStart, setLabelStart, 
        labelEnd, setLabelEnd, labelOpen, setLabelOpen, 
        audienceLabel, setAudienceLabel} = props;

    const memberServices = ["Spa", "Beach", "Golf", "Dining", "Other"]
    const [audienceList, setAudienceList] = useState([]);
    const[memberServicesCheckedState, setMemberServicesCheckedState] = useState(new Array(memberServices.length).fill(false));


    useEffect(() => {
        setAudienceList([
            {id: 1, name: "Yes"}, 
            {id: 2, name: "No"}
        ])

        if(values.membershipServices != null) {
            let selectedMemberServices = values.membershipServices.split(',')

            selectedMemberServices != null && selectedMemberServices.length > 0 && 
            selectedMemberServices.forEach(element => {
                const index = memberServices.indexOf(trim(element));
                memberServicesCheckedState[index] = true;
            })
    
            console.log("selected state ", memberServicesCheckedState);
            setMemberServicesCheckedState(memberServicesCheckedState);
        }
    }, [])

    const handleInputChange = (fieldName, value) => {
        setValues({
          ...values,
          [fieldName]: value
        });
    }

    const handleMemberServices = (position) => {
        var selectedItems = [];
        const updatedMemberServicesCheckedState = memberServicesCheckedState.map((item, index) => {
            if(position == index) {
                return !item;
            } else {
                return item;
            }
        })

        setMemberServicesCheckedState(updatedMemberServicesCheckedState);

        updatedMemberServicesCheckedState.map((item, index) => {
            if(item) {
                selectedItems.push(memberServices[index])
            }
        })

        console.log("Selected member services ", selectedItems.join(', '))
        setValues({
            ...values,
            membershipServices: selectedItems.join(', ')
        })
    }
    
    return (
        <div>
            <div className='entity-additional-container'>
                <div className='column1-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>CTYHOCN</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.ctyhocn ? values.ctyhocn : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.ctyhocn} onChange={(e) => handleInputChange("ctyhocn", e.target.value)}/>)}
                </div>
                <div className='start-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Start Date</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.start ? convertToDateString(new Date(values.start), "picker") : "--"}</div>) : 
                        (<div className='calendar'><Calender minDate={false} maxDate={false} startdate={values.start} 
                        HandleDate={(date) => handleInputChange("start", date)} 
                        HandleLabel={(date) => setLabelStart(convertToDateString(date, "picker"))} label={labelStart}
                        disablefromto={false} disableto={false}
                        /></div>)}
                </div>
                <div className='end-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>End Date</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.end ? convertToDateString(new Date(values.end), "picker") : "--"}</div>) : 
                        (<div className='calendar'><Calender minDate={false} maxDate={false} startdate={values.end} 
                        HandleDate={(date) => handleInputChange("end", date)} 
                        HandleLabel={(date) => setLabelEnd(convertToDateString(date, "picker"))} label={labelEnd}
                        disablefromto={false} disableto={false}
                        /></div>)}
                </div>
            </div>
            <div className='entity-additional-container'>
                <div className='open-date-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Open Date</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.openDate ? convertToDateString(new Date(values.openDate), "picker") : "--"}</div>) : 
                        (<div className='calendar'><Calender minDate={false} maxDate={false} startdate={values.openDate} 
                        HandleDate={(date) => handleInputChange("openDate", date)}
                        HandleLabel={(date) => setLabelOpen(convertToDateString(date, "picker"))} label={labelOpen}
                        disablefromto={false} disableto={false}
                        /></div>)}
                </div>
                <div className='rl-audience-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>R+L Audience</div>
                    {page == "overview-entity" ? 
                    <div className='overview-field'>{(audienceLabel != null && audienceLabel != "Select") ? audienceLabel: "--"}</div> :
                    <Dropdown label={audienceLabel} selectedItem={(name, id) => handleInputChange("rlAudience", id == 1 ? true : false)}
                        handleLabel={(value) => setAudienceLabel(value)} list={audienceList} enable={true}/>}
                </div>
                <div className='region-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Region</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.region ? values.region : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.region} onChange={(e) => handleInputChange("region", e.target.value)}/>)}
                </div>
            </div>
            <div className='entity-additional-container'>
                <div className='brand-portfolio-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Brand Portfolio</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.brandPortfolio ? values.brandPortfolio : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.brandPortfolio} onChange={(e) => handleInputChange("brandPortfolio", e.target.value)}/>)}
                </div>
                <div className='management-type-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Management Type</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.managementType ? values.managementType : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.managementType} onChange={(e) => handleInputChange("managementType", e.target.value)}/>)}
                </div>
                <div className='management-company-record-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Management Company of Record</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.managementCompanyRecord ? values.managementCompanyRecord : "--"}</div>) : 
                        (<input type="text" maxLength={100} value={values.managementCompanyRecord} onChange={(e) => handleInputChange("managementCompanyRecord", e.target.value)}/>)}
                </div>
            </div>
            <div className='entity-additional-container'>
                <div className='operational-ownership-group-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Operational Ownership Group</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.operationalOwnershipGroup ? values.operationalOwnershipGroup : "--"}</div>) : 
                        (<input type="text" maxLength={100} value={values.operationalOwnershipGroup} onChange={(e) => handleInputChange("operationalOwnershipGroup", e.target.value)}/>)}
                </div>
                <div className='location-type-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Location Type</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.locationType ? values.locationType : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.locationType} onChange={(e) => handleInputChange("locationType", e.target.value)}/>)}
                </div>
                <div className='guest-rooms-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Guest Rooms</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.guestRooms ? values.guestRooms : "--"}</div>) : 
                        (<input type="text" maxLength={8} value={values.guestRooms} onChange={(e) => handleInputChange("guestRooms", e.target.value)}/>)}
                </div>
            </div>
            <div className='entity-additional-container'>
                <div className='status-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Status</div>
                    {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.status ? values.status : "--"}</div>) : 
                        (<input type="text" maxLength={45} value={values.status} onChange={(e) => handleInputChange("status", e.target.value)}/>)}
                </div>
            </div>
            <div className='entity-additional-container'>
                <div className='member-program-field additional-field'>
                    <div className={`label ${!(page == "overview-entity") ? 'label-color' : ''}`}>Membership Program</div>
                    <div className={`member-local ${page == "overview-entity" ? "overview-member" : ""}`}>
                        <label className={`${!(page == "overview-entity") ? 'label-color' : 'overview-member-label'}`}>Local: </label>
                        {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.membershipLocal ? values.membershipLocal : "--"}</div>) : 
                        (<input type="text" maxLength={100} value={values.membershipLocal} onChange={(e) => handleInputChange("membershipLocal", e.target.value)}/>)}
                    </div>
                    <div className={`member-resort ${page == "overview-entity" ? "overview-member" : ""}`}>
                        <label className={`${!(page == "overview-entity") ? 'label-color' : 'overview-member-label'}`}>Resort: </label>
                        {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.membershipResort ? values.membershipResort : "--"}</div>) : 
                        (<input type="text" maxLength={100} value={values.membershipResort} onChange={(e) => handleInputChange("membershipResort", e.target.value)}/>)}
                    </div>
                    <div className={`member-services ${page == "overview-entity" ? "overview-member" : ""}`}>
                        <label className={`${!(page == "overview-entity") ? 'label-color' : 'overview-member-label'}`}>Services: </label>
                        {(page == 'overview-entity') ? 
                        (<div className='overview-field'>{values.membershipServices ? values.membershipServices : "--"}</div>) : 
                        <>
                            <div className='checkbox member-services-checkbox'>
                                {(memberServices != null && memberServices.length > 0) && memberServices.map((item, index) => {
                                    return(
                                        <label>
                                            {memberServicesCheckedState != null && <input type="checkbox" onChange={() => handleMemberServices(index)} checked={memberServicesCheckedState[index]}/>}
                                            <span class="checkmark member-services-checkmark"></span>
                                            <span className="label">{item}</span> 
                                        </label>
                                    )
                                })}
                            </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EntityAdditional;